<template>
  <v-dialog :value="true" max-width="400">
    <v-card>
      <v-card-title class="headline">Vincular fatura</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-text-field
            label="Código da fatura *"
            v-model="fields.invoice_id.value"
            :rules="[...fields.invoice_id.rules, ...fields.invoice_id.apiErrors]"
            type="text"
            @input="fields.invoice_id.apiErrors = []"
            outlined dense
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'editRenegotiation',
  props: {
    id: {
      required: false,
      type: [String, Number]
    }
  },
  data: () => ({
    saving: false,
    fields: {
      invoice_id: {
        value: '',
        rules: [
          v => !!v || 'O código da fatura é obrigatório'
        ],
        apiErrors: []
      }
    },
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    saveItem () {
      let vue = this
      vue.saving = true

      let endpoint = (vue.id) ? 'financial-negotiations/' + vue.id : 'financial-negotiations'

      axios(endpoint, {
        method: (vue.id) ? 'patch' : 'post',
        data: vue.apiData
      })
        .then(response => {
          vue.saving = false
          vue.SET_SNACKBAR({ text: 'Fatura vinculada' })
          vue.$emit('edited')
        })
        .catch(() => {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido, por favor tente novamente' })
          vue.saving = false
          vue.$emit('error')
        })
    }
  },
  watch: {
    id () {
      this.fields.invoice_id.value = ''
    },
    item: {
      handler (value) {
        let vue = this

        if (vue.item) {
          for (let key in vue.fields) {
            if (vue.item[key]) vue.fields[key].value = vue.item[key]
          }
        } else {
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$emit('error')
        }
      },
      deep: true
    }
  },
  created () {
    this.fields.invoice_id.value = ''
    // let vue = this

    // if (vue.id && vue.item) {
    //   for (let key in vue.fields) {
    //     if (vue.item[key]) vue.fields[key].value = vue.item[key]
    //   }
    // } else {
    //   vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
    //   vue.$emit('error')
    // }
  }
}
</script>
